import React, { useEffect, useRef } from 'react'
import { Button } from 'semantic-ui-react'
import { isEmptyHtmlContent } from '../../utils/sanitizeHtml'

const SimpleHtmlEditor = ({ value = '', onChange, placeholder = '' }) => {
    const editorRef = useRef(null)
    const lastValueRef = useRef(value)

    useEffect(() => {
        if (!editorRef.current) {
            return
        }
        if (value !== lastValueRef.current) {
            editorRef.current.innerHTML = value || ''
            lastValueRef.current = value
        }
    }, [value])

    useEffect(() => {
        if (editorRef.current && !editorRef.current.innerHTML && value) {
            editorRef.current.innerHTML = value
            lastValueRef.current = value
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const emitChange = () => {
        if (!editorRef.current) {
            return
        }
        const html = editorRef.current.innerHTML
        lastValueRef.current = html
        if (onChange) {
            onChange(html)
        }
    }

    const runCommand = (command, commandValue = null) => {
        editorRef.current?.focus()
        document.execCommand(command, false, commandValue)
        emitChange()
    }

    const handleCreateLink = () => {
        const url = window.prompt('URL', 'https://')
        if (!url) {
            return
        }
        runCommand('createLink', url)
    }

    const empty = isEmptyHtmlContent(value)

    return (
        <div style={{ border: '1px solid rgba(34, 36, 38, 0.15)', borderRadius: 4, background: '#fff' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, padding: 6, borderBottom: '1px solid rgba(34, 36, 38, 0.1)', background: '#f9fafb' }}>
                <Button type='button' size='mini' icon='bold' onClick={() => runCommand('bold')} />
                <Button type='button' size='mini' icon='italic' onClick={() => runCommand('italic')} />
                <Button type='button' size='mini' icon='underline' onClick={() => runCommand('underline')} />
                <Button type='button' size='mini' icon='linkify' onClick={handleCreateLink} />
                <Button type='button' size='mini' icon='list ul' onClick={() => runCommand('insertUnorderedList')} />
                <Button type='button' size='mini' icon='list ol' onClick={() => runCommand('insertOrderedList')} />
                <Button type='button' size='mini' icon='paragraph' onClick={() => runCommand('formatBlock', 'p')} />
                <Button type='button' size='mini' icon='erase' onClick={() => runCommand('removeFormat')} />
            </div>
            <div style={{ position: 'relative' }}>
                {empty && placeholder && (
                    <div
                        style={{
                            position: 'absolute',
                            top: 10,
                            left: 12,
                            right: 12,
                            color: '#999',
                            pointerEvents: 'none',
                            whiteSpace: 'pre-wrap'
                        }}
                    >
                        {placeholder}
                    </div>
                )}
                <div
                    ref={editorRef}
                    contentEditable
                    suppressContentEditableWarning
                    onInput={emitChange}
                    onBlur={emitChange}
                    style={{
                        minHeight: 160,
                        padding: 12,
                        outline: 'none',
                        lineHeight: 1.5,
                        wordBreak: 'break-word'
                    }}
                />
            </div>
        </div>
    )
}

export default SimpleHtmlEditor
